import React from "react";
import TransferHistoryModal from "./TransferHistoryModal";
import { useModal } from "../../../../../contexts/customModal";

const ViewTransferHistory = ({ psid }) => {
  const { showModal } = useModal();

  return (
    <div
      className="btn btn-link p-0"
      onClick={() =>
        showModal({
          title: "Transfer History",
          content: <TransferHistoryModal psid={psid} />,
          maxWidth:"lg"
        })
      }
    >
      Check
    </div>
  );
};

export default ViewTransferHistory;
